import { HttpErrorDetails } from '@rd/types';

const buildTitle = (errors: Array<HttpErrorDetails>): string => {
  return (
    errors?.map((err) => `${err.code} ${err.message}`).join('; ') ||
    'Nydus Error array is empty'
  );
};

export class NydusNetworkAuthError extends Error {
  constructor(public errors: Array<HttpErrorDetails>) {
    super(buildTitle(errors));
    this.name = 'NydusNetworkAuthError'; // prevents sending a minified class name to Sentry
  }

  get fingerprint(): string {
    return (
      this.errors?.map((err) => err.code).join(' ') ||
      'Nydus Error fallback fingerprint'
    );
  }
}
